module.exports = __webpack_public_path__ + "static/img/Sam-Docherty.ccaa15c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam-Docherty.jpg
// module id = L9VL
// module chunks = 0